/**
 * vet-visit-handler.js
 */

 import { Types } from 'utils/constants';


 export default function VetVisitHandler() {
   const type = Types.RecordGroup.VET_VISIT;
 
   /**
    * retrieves record index based on provided type
    */
   const recordIndex = (type, state) => {
     return state.vetVisit;
   }
 
 
   const recordRoute = (type, id) => {
     return `/vet/${id}`;
   }
 
 
   const processRecord = (vetVisit, updateDateIndex, state) => {
     state.vetVisit[vetVisit.id].merge(vetVisit);
 
     if (updateDateIndex) {
       updateDateIndex(vetVisit, state);
     }
     
     return [vetVisit];
   }
   
 
   // public interface
   return ({
     type,
     recordIndex,
     recordRoute,
     processRecord,
   });
 }